export const editMutations = <const>{
	PSEUDO_NAHRADY_ND_SKLAD_SELECT_MAPPER: 'PSEUDO_NAHRADY_ND_SKLAD_SELECT_MAPPER',
};
